import { useState } from 'react'
import { Select } from 'antd'

const FilterJobFairVenue = ({
    filterValue,
    setFilterValue,
    setCurrentPage
}) => {
    const [tempfilterValue, setTempFilterValue] = useState({})

    let campusItems = [
        {
            value: 0,
            label: '全部'
        },
        {
            value: 1,
            label: '兰州职业技术学院'
        },
        {
            value: 2,
            label: '雁儿湾校区'
        },
        {
            value: 3,
            label: '桃林校区'
        }
    ]

    const clickCampusFilter = (value) => {
        setTempFilterValue({ ...tempfilterValue, campus: value })
    }

    const clickSubmitFilter = () => {
        setFilterValue({ ...filterValue, ...tempfilterValue })
        setCurrentPage(1)
    }

    const clickResetFilter = () => {
        setFilterValue({ ...filterValue, campus: 0 })
        setTempFilterValue({})
    }

    return (
        <div className='public-conditions'>
            <div className='public-conditions-row'>
                <div className='public-condition'>
                    <div className='public-condition-label'>校区：</div>
                    <Select
                        value={tempfilterValue.campus}
                        placeholder="请选择"
                        options={campusItems}
                        style={{ width: '220px' }}
                        onChange={(value) => clickCampusFilter(value)}
                    />
                </div>
            </div>

            <div className='public-conditions-buttons'>
                <div className='public-conditions-button1' onClick={() => { clickSubmitFilter() }}>筛选</div>
                <div className='public-conditions-button2' onClick={() => { clickResetFilter() }}>重置</div>
            </div>
        </div>
    )
}

export default FilterJobFairVenue
